import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import "./scss/index.scss";

import { connect } from "react-redux";

import PropTypes from "prop-types";

import MainAppContainer from "./components/MainComponents/MainAppContainer";

import ErrorMessage from "./utils/ErrorMessage";
import { useTranslation } from "react-i18next";
import Loader from "./utils/Loader";
import { useEffect } from "react";
import { getInitialUserToken } from "./actions/configActions";
import { bindActionCreators } from "redux";

const App = ({
  userToken,
  getInitialUserToken,
  initialUserRightHasBeenLoaded,
  initialUserRightHasBeenLoadedWithError,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!userToken) {
      getInitialUserToken();
    }
  }, [userToken, getInitialUserToken]);

  if (initialUserRightHasBeenLoadedWithError) {
    return (
      <div className="App">
        <ErrorMessage message={t("errorWithBackEndRequest")} />
      </div>
    );
  }

  if (!initialUserRightHasBeenLoaded) {
    return (
      <div className="App">
        <Loader />
      </div>
    );
  }

  return (
    <div className="App">
      <MainAppContainer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInitialUserToken: bindActionCreators(getInitialUserToken, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    initialUserRightHasBeenLoaded:
      state.configReducer.initialUserRightHasBeenLoaded,
    initialUserRightHasBeenLoadedWithError:
      state.configReducer.initialUserRightHasBeenLoadedWithError,
  };
};

App.propTypes = {
  userToken: PropTypes.string.isRequired,
  initialUserRightHasBeenLoaded: PropTypes.bool.isRequired,
  initialUserRightHasBeenLoadedWithError: PropTypes.bool.isRequired,
  getInitialUserToken: PropTypes.func.isRequired,
};

App.defaultProps = {
  userToken: "",
  initialUserRightHasBeenLoaded: false,
  initialUserRightHasBeenLoadedWithError: false,
  getInitialUserToken: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
